import { AhPlusPricingPlans } from "modules/storyblok/components";
import type { AhPlusPricingPlansProps } from "modules/storyblok/components/AhPlusPricingPlans";
import type { ReactStoryblokComponent } from "types/storyblok";

const AhPlusPricingPlansAdapter = ({
  blok: {
    bottomText,
    cards,
    horizontalPaddingDesktop,
    horizontalPaddingMobile,
    verticalPaddingDesktop,
    verticalPaddingMobile,
  },
}: ReactStoryblokComponent<AhPlusPricingPlansProps>) => (
  <AhPlusPricingPlans
    horizontalPaddingMobile={horizontalPaddingMobile}
    horizontalPaddingDesktop={horizontalPaddingDesktop}
    verticalPaddingDesktop={verticalPaddingDesktop}
    verticalPaddingMobile={verticalPaddingMobile}
    bottomText={bottomText}
    cards={cards}
  />
);

export default AhPlusPricingPlansAdapter;
